import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.BUSINESS };

const path = "business/business-profile";
const stripePath = "business/stripe";

export const CompleteProfile = async (values) => {
  return await axiosInstance(options).post(`${path}/complete-profile`, values);
};

// Create Stripe connected account
export const createStripeAccount = async () => {
  return await axiosInstance(options).get(`${stripePath}/create_account`);
};

// Create account link for Stripe Connect (for hosted onboarding)
export const createAccountLink = async (accountId) => {
  return await axiosInstance(options).post(`${stripePath}/account_link`, {
    account: accountId,
  });
};

// Check account status
export const accountStatus = async () => {
  return await axiosInstance(options).get(`${stripePath}/account_status`);
};
